<h1 class="route-title">{{ routeTitle$ | ngrxPush }}</h1>

<div class="portal-outlet-container">
    <ng-template *ngIf="componentPortalItem$ | ngrxPush as componentPortalItem" [cdkPortalOutlet]="componentPortalItem" />
</div>

<ng-content select="[notificationsSlot]" />
<ng-content select="[languageSlot]" />
<ng-content select="[userButtonSlot]" />
